import Handorgel from 'handorgel';

function mount({ rootElement = null }) {
  const accordions = rootElement.querySelectorAll('.accordion.handorgel');

  [...accordions].forEach((a) => {
    // eslint-disable-next-line no-unused-vars
    const accordion = new Handorgel(a, {
      multiSelectable: false,
    });
  });
}

function init() {
  const blocks = document.querySelectorAll('.section--openings-listing');

  [...blocks].forEach((block) => {
    mount({ rootElement: block });
  });
}

export default init;
